import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import './styles/tokens.css';
import './styles/global.css';
import { App } from './app/App';
import { applyLocale, getLocale } from './lib/locale';
import { applyFontScale, savedFontScale } from './lib/appearance';

applyLocale(getLocale());
applyFontScale(savedFontScale());

const container = document.getElementById('root');
if (!container) {
  throw new Error('Elemento raiz #root não encontrado no documento.');
}

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
